import { render } from "./App.vue?vue&type=template&id=ae7c24d8"
const script = {}

import "./App.vue?vue&type=style&index=0&id=ae7c24d8&lang=css"

import exportComponent from "/home/debian/quiz-anatomie/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__